import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args))),
      type: "checkbox",
      id: "theme_switch",
      class: "theme-switch"
    }),
    _cache[1] || (_cache[1] = _createElementVNode("label", {
      for: "theme_switch",
      class: "checkbox-label"
    }, [
      _createElementVNode("span", { class: "round" })
    ], -1))
  ]))
}